export default __webpack_public_path__ + "static/media/bg.7e99a07c.jpg";